/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPointsHistoryCreateReqVo
 */
export interface UserPointsHistoryCreateReqVo {
    /**
     * Points id
     * @type {number}
     * @memberof UserPointsHistoryCreateReqVo
     */
    pointsId: number;
    /**
     * Changed points amount
     * @type {number}
     * @memberof UserPointsHistoryCreateReqVo
     */
    amount: number;
    /**
     * Points balance after change
     * @type {number}
     * @memberof UserPointsHistoryCreateReqVo
     */
    principal: number;
    /**
     * Points in/out type: 0 out, 1 in
     * @type {number}
     * @memberof UserPointsHistoryCreateReqVo
     */
    intOutType: number;
    /**
     * Remark
     * @type {string}
     * @memberof UserPointsHistoryCreateReqVo
     */
    remark?: string;
    /**
     * User id
     * @type {number}
     * @memberof UserPointsHistoryCreateReqVo
     */
    userId: number;
    /**
     * Enable status: 0 disabled, 1 enabled
     * @type {number}
     * @memberof UserPointsHistoryCreateReqVo
     */
    enable: number;
    /**
     * Change reason
     * @type {number}
     * @memberof UserPointsHistoryCreateReqVo
     */
    changeReason: number;
}

/**
 * Check if a given object implements the UserPointsHistoryCreateReqVo interface.
 */
export function instanceOfUserPointsHistoryCreateReqVo(value: object): value is UserPointsHistoryCreateReqVo {
    if (!('pointsId' in value) || value['pointsId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('principal' in value) || value['principal'] === undefined) return false;
    if (!('intOutType' in value) || value['intOutType'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    if (!('changeReason' in value) || value['changeReason'] === undefined) return false;
    return true;
}

export function UserPointsHistoryCreateReqVoFromJSON(json: any): UserPointsHistoryCreateReqVo {
    return UserPointsHistoryCreateReqVoFromJSONTyped(json, false);
}

export function UserPointsHistoryCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPointsHistoryCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'pointsId': json['pointsId'],
        'amount': json['amount'],
        'principal': json['principal'],
        'intOutType': json['intOutType'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'userId': json['userId'],
        'enable': json['enable'],
        'changeReason': json['changeReason'],
    };
}

export function UserPointsHistoryCreateReqVoToJSON(json: any): UserPointsHistoryCreateReqVo {
    return UserPointsHistoryCreateReqVoToJSONTyped(json, false);
}

export function UserPointsHistoryCreateReqVoToJSONTyped(value?: UserPointsHistoryCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pointsId': value['pointsId'],
        'amount': value['amount'],
        'principal': value['principal'],
        'intOutType': value['intOutType'],
        'remark': value['remark'],
        'userId': value['userId'],
        'enable': value['enable'],
        'changeReason': value['changeReason'],
    };
}

